'use strict';

/**
 * @classname ShopSelect
 * @classdesc お気に入り店舗選択
 */
export default class ShopSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-select-favorite-shop
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		$('.btn--select-shop').on('click', () => this.selectShop());
		$('.btn--skip-select-shop').on('click', () => this.skipSelectShop());
	};


	/**
	 * お気に入り店舗選択
	 *
	 * @memberof ShopSelect
	 * @return undefined
	 */
	selectShop() {
		if($('.btn--select-shop').prop('disabled')) return;
		console.log(`${this.constructor.name}.selectShop`);
		const $checked = $('.favorite-shop-select:checked');
		const shopId = $checked.val();
		const $label = $checked.closest('.input-radio').find('label div');
		const shopName = $label.find('strong').text();
		const shopAddress = $label.find('.text').eq(0).text();
		const shopBusinessHours = $label.find('.text').eq(1).text();
		let favoriteShop = {
			shopId: shopId,
			shopName: shopName,
			shopAddress: shopAddress,
			shopBusinessHours: shopBusinessHours
		}
		favoriteShop = JSON.stringify(favoriteShop);
		window.localStorage.setItem('_cfs_', favoriteShop);
		const url = window.localStorage.getItem('_mvu_') || '/';
		window.localStorage.removeItem('_mvu_');
		setTimeout(() => {
			location.href = url;
		},500);
	};


	/**
	 * お気に入り店舗選択スキップ
	 *
	 * @memberof ShopSelect
	 * @return undefined
	 */
	skipSelectShop() {
		console.log(`${this.constructor.name}.skipSelectShop`);
		window.localStorage.setItem('_cfs_', '{}');
		const url = window.localStorage.getItem('_mvu_') || '/';
		window.localStorage.removeItem('_mvu_');
		setTimeout(() => {
			location.href = url;
		},100);
	};
};
